<div class="d-flex justify-content-between align-items-center w-100 mt-1">
	<!-- Encerramento forçado (spec 024) temporariamente OCULTO em tela, a pedido — o fluxo e o
		backend permanecem intactos; para reativar, restaure o botão abaixo dentro do @if original
		(!demand.loose && !demand.noticeSession.forcedClosure):
		<button class="ms-2 btn btn-sm btn-link text-danger fw-700 ps-0" (click)="sessionForcedClosed()" [disabled]="submitted" *permissions="'dispute.session.manage'">
			Encerrar Sessão
		</button>
	-->
	<p class="mt-3 mb-0 text-muted fw-700"></p>
	<div class="mb-2">
		<!--
			Abrir, Fechar e Reabrir (e o indicativo do encerramento forçado) vivem no `app-notice-session-actions`.
			Com disputa ficam no cabeçalho da aba Disputa (28/09/2026) e não se repetem aqui — ver `sessionActionsHidden`.
		-->
		@if (demand.noticeSession.forcedClosure) {
			@if (!sessionActionsHidden) {
				<app-notice-session-actions [demand]="demand"></app-notice-session-actions>
			}
			<button class="btn btn-sm btn-white ms-2 rounded-2" (click)="fetchSuppliersEnrollmentNotice()">
				<fa-icon icon="refresh"></fa-icon>
			</button>
		} @else {
			@if (demand.loose) {
				@if (demand.publishStatusDone) {
					@if (demand.noticeSession.statusOpened) {
						<button class="btn btn-sm btn-indigo fw-700 rounded-2" (click)="loosePublishSupplier()" *permissions="'dispute.session.export'">
							Publicar {{ demand.process.modality === ProcessModality.PRE_QUALIFICATION ? 'Certificados' : 'Termos' }}
						</button>

						<button class="ms-2 btn btn-sm btn-danger fw-700 rounded-2" (click)="looseClosed()" [disabled]="submitted || submittedLocking">
							<app-label-loading-dots [loading]="submitted" label="Fechar Sessão"></app-label-loading-dots>
						</button>
					} @else if (demand.noticeSession.statusClosed) {
						<button class="ms-2 btn btn-sm btn-primary fw-700" (click)="reportFinal()" *permissions="'dispute.session.export'">
							Relatório Final
						</button>

						<button
							class="ms-2 btn btn-sm btn-indigo fw-700 rounded-2"
							(click)="looseOpened()"
							[disabled]="submitted"
							*permissions="'dispute.session.manage'">
							<app-label-loading-dots [loading]="submitted" label="Reabrir Sessão"></app-label-loading-dots>
						</button>
					}
				}

				@if (demand.publishStatusDone && demand.noticeSession.statusOpened) {
					<button
						class="ms-2 btn btn-sm fw-700 rounded-2"
						[class.btn-danger]="!demand.noticeSession.locked"
						[class.btn-indigo]="demand.noticeSession.locked"
						(click)="looseLocked()"
						[disabled]="submitted || submittedLocking"
						*permissions="'dispute.session.manage'">
						<app-label-loading-dots
							[loading]="submittedLocking"
							[label]="demand.noticeSession.locked ? 'Continuar Recebendo' : 'Pausar Recebimento'"></app-label-loading-dots>
					</button>
				}

				<button class="btn btn-sm btn-white ms-2 rounded-2" (click)="fetchSuppliersEnrollmentNotice()">
					<fa-icon icon="refresh"></fa-icon>
				</button>
			} @else {
				@if (!sessionActionsHidden) {
					<app-notice-session-actions [demand]="demand" (statusChange)="onSessionStatusChange($event)"></app-notice-session-actions>
				}

				<button class="btn btn-sm btn-white ms-2 rounded-2" (click)="fetchSuppliersEnrollmentNotice()"><fa-icon icon="refresh"></fa-icon></button>
			}
		}
	</div>
</div>
<hr class="mt-0" />
<ul class="list-group list-group-flush">
	@if (supplierEnrollmentNotice$ | async; as enrollmentNoticePaginate) {
		@if (enrollmentNoticePaginate.empty) {
			<div class="d-flex align-items-center justify-content-center w-100" style="height: 50vh">
				<app-empty-data message="Nenhum participante no momento..."></app-empty-data>
			</div>
		} @else {
			<li class="list-group-item bg-white">
				<div class="d-flex justify-content-between align-items-center">
					<div class="w-75 fw-700">Detalhes</div>
					<div class="w-auto fw-700 text-center">Ações</div>
				</div>
			</li>
			@for (item of enrollmentNoticePaginate.content; track item.id; let e = $even) {
				<li class="list-group-item p-3" [class.bg-gray-200]="e">
					<div class="d-flex justify-content-between align-items-center">
						<div class="w-75">
							@if (!participantIdentityHidden) {
								<small class="text-muted">{{ item.supplier.document | mask: 'CPF_CNPJ' }}</small>
							}
							<p class="text-uppercase fw-700 mb-0">{{ participantDisplayName(item) }}</p>
							@if (!participantIdentityHidden) {
								<small class="w-100 d-inline-block">{{ label.formattedAddress(item.supplier.address) }}</small>
								<small class="w-100 d-inline-block fw-500">
									{{ item.supplier.phone | mask: '(00) 0 0000-0000' }} | {{ item.supplier.email }}
								</small>
							}

							@if (item.attachment) {
								<hr class="mb-2 mt-2" />
							}

							<div class="d-flex justify-content-start">
								@if (item.attachment) {
									<small>
										Documentação enviada em
										<b>{{ item.documentationDate | date: 'dd/MM/yyyy HH:mm' }}</b>
									</small>
								}
							</div>
						</div>
						<div class="w-25 d-flex justify-content-between align-items-center">
							@if (demand.loose) {
								@if (item.statusCreated && item.attachment) {
									<div class="d-flex justify-content-center align-items-center w-100 flex-column">
										<div class="btn-group rounded-2 w-50">
											<button
												class="btn btn-sm btn-primary fw-600"
												[disabled]="demand?.statusCanceled"
												(click)="modalSupplierAction(item, SupplierEnrollmentNoticeStatus.APPROVED)">
												Qualificar
											</button>
											<button
												class="btn btn-sm btn-danger fw-600"
												[disabled]="demand?.statusCanceled"
												(click)="modalSupplierAction(item, SupplierEnrollmentNoticeStatus.REJECTED)">
												Rejeitar
											</button>
										</div>
									</div>
								} @else {
									<div class="d-flex justify-content-center align-content-center w-100">
										<small
											class="badge fw-600 cursor-pointer"
											[ngbTooltip]="tipContent"
											[class.text-bg-info]="item.statusCreated"
											[class.text-bg-orange]="item.statusCanceled"
											[class.text-bg-danger]="item.statusRejected"
											[class.text-bg-primary]="item.statusApproved">
											<fa-icon icon="question-circle" class="me-1"></fa-icon>
											{{ item.statusLabel }}
										</small>

										@if (item.published) {
											<small class="ms-2 badge badge-sm rounded-2 fw-600 text-bg-success">Publicado</small>
										}
										@if (item.withdrawn) {
											<!-- PC-06: o licitante desistiu depois da abertura; a desclassificação segue pelo fluxo normal. -->
											<small
												class="ms-2 badge badge-sm rounded-2 fw-600 text-bg-danger cursor-pointer"
												data-testid="enrollment-withdrawn"
												[ngbTooltip]="
													'Desistiu em ' + (item.withdrawnAt | date: 'dd/MM/yyyy HH:mm') + ': ' + item.withdrawalJustification
												"
												container="body">
												<fa-icon icon="flag" class="me-1"></fa-icon>
												Desistiu
											</small>
										}
									</div>

									<ng-template #tipContent><div [innerHtml]="item.lastMessage"></div></ng-template>
								}
							} @else {
								<div class="d-flex justify-content-center align-content-center w-100">
									<small
										class="badge fw-600 cursor-pointer"
										[ngbTooltip]="tipContentDispute"
										[class.text-bg-info]="item.statusCreated"
										[class.text-bg-danger]="
											item.statusRejected ||
											item.statusProposalQualificationRejected ||
											item.statusCanceled ||
											item.statusProposalInapposite
										"
										[class.text-bg-secondary]="item.statusProposalQualificationApproved || item.statusProposalAppropriate"
										[class.text-bg-primary]="item.statusApproved"
										[class.text-bg-orange]="item.statusProposalSent"
										[class.text-bg-indigo]="item.statusProposalTrading">
										<fa-icon icon="question-circle" class="me-1"></fa-icon>
										{{ item.statusProposalTrading && item.tradingClosed ? 'Negociação encerrada' : item.disputaStatusLabel }}
									</small>

									@if (item.published) {
										<small class="ms-2 badge badge-sm rounded-2 fw-600 text-bg-success">Publicado</small>
									}
									@if (item.withdrawn) {
										<!-- PC-06: o licitante desistiu depois da abertura; a desclassificação segue pelo fluxo normal. -->
										<small
											class="ms-2 badge badge-sm rounded-2 fw-600 text-bg-danger cursor-pointer"
											data-testid="enrollment-withdrawn"
											[ngbTooltip]="'Desistiu em ' + (item.withdrawnAt | date: 'dd/MM/yyyy HH:mm') + ': ' + item.withdrawalJustification"
											container="body">
											<fa-icon icon="flag" class="me-1"></fa-icon>
											Desistiu
										</small>
									}
								</div>

								<ng-template #tipContentDispute>
									<div [innerHtml]="demand.loose ? item.lastMessage : label.fromSupplierEnrollmentNoticeStatuses(item.status)?.title"></div>
								</ng-template>
							}

							@if (item.deleting) {
								<app-pre-loading [inline]="true" [large]="false" [showMessage]="false"></app-pre-loading>
							} @else {
								<div class="dropdown no-caret" ngbDropdown container="body">
									<button
										class="btn btn-icon btn-transparent-dark dropdown-toggle position-relative"
										[disabled]="demand.loose && item.statusCreated && !item.attachment"
										ngbDropdownToggle>
										<fa-icon class="text-dark" icon="ellipsis-vertical"></fa-icon>
									</button>

									<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu aria-labelledby="actions">
										@if (demand.loose) {
											@if (item.noticeSession.statusOpened && !item.statusCreated) {
												<button
													class="dropdown-item"
													(click)="
														modalSupplierAction(
															item,
															SupplierEnrollmentNoticeStatus.CREATED,
															SupplierEnrollmentNoticeMessageType.REOPENED
														)
													">
													<div class="dropdown-item-icon"><fa-icon icon="refresh"></fa-icon></div>
													Desfazer julgamento
												</button>
											}

											@if (item.attachment) {
												@if (item.noticeSession.statusOpened) {
													<button class="dropdown-item" (click)="modalRepresentation(item)">
														<div class="dropdown-item-icon"><fa-icon icon="clipboard-check"></fa-icon></div>
														Diligência
														@if (item.representations?.length > 0) {
															<span class="badge badge-sm text-bg-danger rounded-pill fw-600 ms-2 mb-1">
																{{ item.representations.length }}
															</span>
														}
													</button>
												}

												<button
													class="dropdown-item"
													(click)="modalAttachmentSupplierDownload(item, SupplierEnrollmentNoticeAttachmentType.PRINCIPAL, true)">
													<div class="dropdown-item-icon"><fa-icon icon="file-contract"></fa-icon></div>
													Documentos
												</button>

												@if (!item.statusCreated) {
													@if (item.reportAnalytics) {
														<button
															class="dropdown-item"
															(click)="attachmentSupplierToPDFDownload(item, SupplierEnrollmentNoticeAttachmentType.ANALYTICS)">
															<div class="dropdown-item-icon">
																<fa-icon icon="chart-column"></fa-icon>
															</div>
															Relatório de Análise
														</button>
													}

													@if (item.certificated && item.statusApproved) {
														<button
															class="dropdown-item"
															(click)="
																attachmentSupplierToPDFDownload(item, SupplierEnrollmentNoticeAttachmentType.CERTIFICATED)
															">
															<div class="dropdown-item-icon">
																<fa-icon icon="certificate"></fa-icon>
															</div>
															{{ demand.process.modality === ProcessModality.ACCREDITATION ? 'Credenciamento' : 'Certificado' }}
														</button>
													}
													@if (!item.published) {
														<button class="dropdown-item" (click)="modalGenerateCertificate(item, item.status, true)">
															<div class="dropdown-item-icon">
																<fa-icon icon="certificate"></fa-icon>
															</div>
															Gerar Doc. Complementares
														</button>
													}
												}
											}

											@if (item.published && item.noticeSession.statusOpened) {
												<button
													class="dropdown-item text-danger"
													[disabled]="item.deleting"
													(click)="unpublishSupplierLooseOther(item)"
													*permissions="'dispute.enrollment.manage'">
													<div class="dropdown-item-icon"><fa-icon icon="trash"></fa-icon></div>
													Remover Publicação
												</button>
											}
										} @else {
											<button class="dropdown-item" (click)="modalBids(item)">
												<div class="dropdown-item-icon"><fa-icon icon="file-signature"></fa-icon></div>
												{{ proposalsMenuLabel }}
											</button>

											@if (item.proposal) {
												@if (!item.statusProposalInapposite || item.trading || item.tradingClosed) {
													@if (canShowTradingButton(item) && !hasOpenedBidPhaseInDispute) {
														<button class="dropdown-item" (click)="modalTrades(item)">
															<div class="dropdown-item-icon"><fa-icon icon="handshake"></fa-icon></div>
															Negociação
														</button>
													}
													@if (canShowAdjustedProposalAction(item)) {
														<button
															class="dropdown-item"
															(click)="modalFeasibilityAdjustedProposal(item, 'adjusted')"
															*permissions="'dispute.diligence.create'">
															<div class="dropdown-item-icon">
																<fa-icon icon="file-pen"></fa-icon>
															</div>
															Proposta Readequada
														</button>
													}

													<button
														class="dropdown-item"
														(click)="modalFeasibilityAdjustedProposal(item, 'feasibility')"
														*permissions="'dispute.diligence.create'">
														<div class="dropdown-item-icon">
															<fa-icon icon="check-circle"></fa-icon>
														</div>
														Exequibilidade
														@if (item.feasibilityTotal > 0) {
															<span class="badge badge-sm text-bg-danger rounded-pill fw-600 ms-2 mb-1">
																{{ item.feasibilityTotal }}
															</span>
														}
													</button>
												}
											}

											<button class="dropdown-item" (click)="modalDisputeAttachmentSupplierDownload(item, true)">
												<div class="dropdown-item-icon"><fa-icon icon="file-contract"></fa-icon></div>
												Documentação
											</button>

											<div class="dropdown-divider"></div>

											<button class="dropdown-item" (click)="modalRepresentation(item)">
												<div class="dropdown-item-icon"><fa-icon icon="clipboard-check"></fa-icon></div>
												Diligência
												@if (item.representations?.length > 0) {
													<span class="badge badge-sm text-bg-danger rounded-pill fw-600 ms-2 mb-1">
														{{ item.representations.length }}
													</span>
												}
											</button>

											<!--
												Habilitação (iniciar prazo, julgar, desfazer) saiu daqui: é por proposta arrematada, na
												Classificação (spec 043).
											-->
											<div class="dropdown-divider"></div>

											<button class="dropdown-item" (click)="modalLogActives(item)">
												<div class="dropdown-item-icon">
													<fa-icon icon="clock-rotate-left"></fa-icon>
												</div>
												Histórico
											</button>
										}

										@if (item.counterargument) {
											<button class="dropdown-item" (click)="modalCounterargument(item)">
												<div class="dropdown-item-icon"><fa-icon icon="file-shield"></fa-icon></div>
												Recursos/Contrarrazões
											</button>
										}

										<div class="dropdown-divider"></div>

										<button class="dropdown-item" (click)="modalEnrollmentEvents(item)">
											<div class="dropdown-item-icon"><fa-icon icon="stream"></fa-icon></div>
											Eventos
										</button>
									</div>
								</div>
							}
						</div>
					</div>
				</li>
			}

			@if (enrollmentNoticePaginate.totalPages > 1) {
				<div class="d-flex justify-content-between align-items-center ps-0 pt-3 pb-3">
					<div class="d-flex flex-row align-items-center">
						<small class="text-muted ps-0 pe-3">Total de {{ enrollmentNoticePaginate.totalElements | number }} registro(s)</small>
						<ngb-pagination
							[rotate]="true"
							[maxSize]="5"
							[pageSize]="enrollmentNoticePaginate.size"
							[page]="enrollmentNoticePaginate.page + 1"
							[collectionSize]="enrollmentNoticePaginate.totalElements"
							(pageChange)="fetchSuppliersEnrollmentNotice($event - 1, supplierEnrollmentNoticeParams)"></ngb-pagination>
					</div>
				</div>
			}
		}
	} @else {
		<div class="d-flex align-items-center justify-content-center w-100" style="height: 50vh">
			<app-pre-loading msg="Buscando participantes, aguarde"></app-pre-loading>
		</div>
	}
</ul>

<!--Modal approve/reject supplier-->
<ng-template #modalConfirmJudgingSupplier let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ supplierEnrollmentNoticeLabel }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body p-3">
		<div class="row">
			<div class="col-md-12 mb-2">
				<small class="text-muted">Fornecedor</small>
				<p class="fw-700 text-uppercase">{{ participantDisplayName(supplierEnrollmentNotice) }}</p>
			</div>
			<div class="col-md-12 mb-3">
				<label for="description" class="form-label">Descrição do motivo para {{ supplierEnrollmentNoticeStatusLabel }}</label>
				<textarea
					class="form-control"
					id="description"
					appTextLimited
					[limited]="2000"
					style="height: 100px"
					[formControl]="descriptionControl"></textarea>
			</div>
		</div>

		<div class="row">
			<div
				class="mb-3"
				[class.col-md-12]="!confirmSubmitted && !fileUploadAttachmentDocument?.status"
				[class.col-md-10]="confirmSubmitted || fileUploadAttachmentDocument?.status">
				<label for="file" class="form-label">Caso necessário anexe um documento em PDF</label>
				<input
					class="form-control form-control-lg"
					[class.is-invalid]="fileAttachmentControlInvalid"
					(change)="onAttachmentSelected($event)"
					id="file"
					type="file"
					[disabled]="submittedAttachment" />
				@if (fileAttachmentControl.hasError('required')) {
					<div class="invalid-feedback">Informe o anexo</div>
				}
			</div>

			<div
				class="mt-3 d-flex align-items-center justify-content-center flex-column"
				[class.d-none]="!confirmSubmitted && !fileUploadAttachmentDocument?.status"
				[class.col-md-2]="confirmSubmitted || fileUploadAttachmentDocument?.status">
				@if (confirmSubmitted && fileUploadAttachmentDocument?.status !== 'UPLOADED') {
					<app-pre-loading [inline]="true" [large]="false" [showMessage]="false"></app-pre-loading>
					<p class="mb-0">Enviando</p>
				} @else if (fileUploadAttachmentDocument?.status === 'ERROR') {
					<small>
						<fa-icon icon="times-circle" class="text-danger" ngbTooltip="Tívemos um problema ao enviar o documento de habilitação"></fa-icon>
					</small>
					<p class="mb-0">Error</p>
				} @else if (fileUploadAttachmentDocument?.status === 'UPLOADED') {
					<small><fa-icon icon="check-circle" class="text-success" ngbTooltip="Enviado com sucesso"></fa-icon></small>
					<p class="mb-0">Enviado</p>
				}
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-link me-2" (click)="modal.dismiss()">
			<fa-icon icon="reply" class="me-2"></fa-icon>
			Voltar
		</button>

		<button class="btn btn-primary" (click)="confirmSupplierJudging()" [disabled]="confirmSubmitted" *permissions="'dispute.proposal.approve'">
			<app-label-loading-dots [loading]="confirmSubmitted" label="Confirmar"></app-label-loading-dots>
		</button>
	</div>
</ng-template>

<!--Modal messages-->
<ng-template #modalMessages let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">Mensagens</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-md-12">
				@if (messages.length === 0) {
					<div class="p-5">
						<app-empty-data message="Nenhuma mensagem encontrada..."></app-empty-data>
					</div>
				} @else {
					<ul class="list-group list-group-flush">
						@for (item of messages; track item.id) {
							<li class="list-group-item">
								@if (item.submitted) {
									<app-pre-loading [inline]="true" [large]="false" msg="Baixando anexo, aguarde"></app-pre-loading>
								} @else {
									<div class="d-flex flex-column">
										<div
											class="message-bubble system align-self-start w-100"
											style="max-width: 100%"
											(click)="enrollmentMessageAttachmentDownload(item, item.id)"
											[class.cursor-pointer]="item.hasAttachment"
											[innerHTML]="item.customMessage"></div>
									</div>
								}
							</li>
						}
					</ul>
				}
			</div>
		</div>
	</div>
</ng-template>

<!--Modal counterargument-->
<ng-template #modalCounterarguments let-modal>
	@if (supplierEnrollmentNotice) {
		<div class="modal-header">
			<div class="w-100 d-flex justify-content-between align-items-center">
				<h4 class="modal-title" id="modal-basic-title">Recursos/Contrarrazões</h4>
				<div class="d-flex align-items-center">
					<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
				</div>
			</div>
		</div>
		<div class="modal-body">
			@if (counterarguments$ | async; as counterargumentPaginate) {
				@if (counterargumentPaginate.empty) {
					<div class="p-5">
						<app-empty-data message="Ainda não foi enviado a contrarrazão..."></app-empty-data>
					</div>
				} @else {
					<ul class="list-group">
						@for (counter of counterargumentPaginate.content; track counter.id) {
							<ng-container *ngTemplateOutlet="counterargument; context: { counter, supplier: false }"></ng-container>
						}
					</ul>
				}
			} @else {
				<app-pre-loading></app-pre-loading>
			}
		</div>
	}
</ng-template>

<!--Modal publish supplier approve-->
<ng-template #modalPublishLooseOther let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Publicar Participantes Qualificados</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body p-3">
		@if (supplierEnrollmentNoticesLoading) {
			<app-pre-loading msg="Buscando participantes qualificados, aguarde"></app-pre-loading>
		} @else {
			@if (supplierEnrollmentNotices.length === 0) {
				<div class="p-5">
					<app-empty-data message="Nenhum participante qualificado para incluir na publicação."></app-empty-data>
				</div>
			} @else {
				<div class="row">
					<div class="col-md-12">
						<ul class="list-group list-group-flush mt-3">
							@for (item of supplierEnrollmentNotices; track item.id) {
								<li class="list-group-item p-3">
									<div class="d-flex justify-content-between align-items-center">
										<div>
											@if (!participantIdentityHidden) {
												<small class="text-muted">{{ item.supplier.document | mask: 'CPF_CNPJ' }}</small>
											}
											<p class="text-uppercase fw-700 mb-0">{{ participantDisplayName(item) }}</p>
											@if (!participantIdentityHidden) {
												<small class="w-100 d-inline-block">{{ label.formattedAddress(item.supplier.address) }}</small>
												<small class="w-100 d-inline-block fw-500">
													{{ item.supplier.phone | mask: '(00) 0 0000-0000' }} | {{ item.supplier.email }}
												</small>
											}

											@if (item.publishError) {
												<small class="w-100 d-inline-block text-danger">{{ item.publishError }}</small>
											}
										</div>
										<div class="d-flex flex-column">
											@if (item.published) {
												<button class="mt-3 btn btn-sm btn-outline-light border-0 text-primary fw-600" disabled>Publicado</button>
											} @else {
												<button
													class="mt-3 btn btn-sm btn-outline-light border-0 text-info fw-600"
													(click)="confirmPublishLooseSupplierOther(item)"
													[disabled]="item.submitted"
													*permissions="'dispute.session.export'">
													@if (item.submitted) {
														<app-pre-loading [showMessage]="false" [large]="false"></app-pre-loading>
													} @else {
														Publicar
													}
												</button>
											}
										</div>
									</div>
								</li>
							}
						</ul>
					</div>
				</div>
			}
		}
	</div>
	@if (!supplierEnrollmentNoticesLoading && supplierEnrollmentNotices.length > 0) {
		<div class="modal-footer">
			<button class="btn btn-link me-2" (click)="modal.dismiss()">
				<fa-icon icon="reply" class="me-2"></fa-icon>
				Voltar
			</button>

			<button
				class="btn btn-primary fw-600"
				(click)="confirmAllPublishLooseSupplierOther()"
				[disabled]="submitted || supplierEnrollmentNoticesLoading"
				*permissions="'dispute.session.export'">
				<fa-icon icon="paper-plane" class="me-2"></fa-icon>
				<app-label-loading-dots [loading]="submitted" label="Publicar Todos"></app-label-loading-dots>
			</button>
		</div>
	}
</ng-template>

<!--Modal rejected all supplier pending-->
<ng-template #modalRejectedSupplierPending let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title">
				<b>Atenção</b>
				- Antes de prosseguir valida as informações abaixo
			</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<div class="col-md-12">
			<ul class="list-group list-group-flush">
				@for (item of supplierEnrollmentNotices; track item.id) {
					<li class="list-group-item bg-white">
						<div class="d-flex justify-content-between align-items-center">
							<div class="w-75">
								@if (!participantIdentityHidden) {
									<small class="text-muted">{{ item.supplier.document | mask: 'CPF_CNPJ' }}</small>
								}
								<p class="text-uppercase fw-700 mb-0">{{ participantDisplayName(item) }}</p>
								@if (!participantIdentityHidden) {
									<small class="w-100 d-inline-block">{{ label.formattedAddress(item.supplier.address) }}</small>
									<small class="w-100 d-inline-block fw-500">
										{{ item.supplier.phone | mask: '(00) 0 0000-0000' }} | {{ item.supplier.email }}
									</small>
								}
							</div>
							<div class="w-25">
								<small class="text-muted">Cadastrado</small>
								<small class="w-100 d-inline-block fw-500">{{ item.created | date: 'dd/MM/yyyy HH:mm' }}</small>
							</div>
						</div>
					</li>
				}
			</ul>
		</div>

		<div class="col-md-12 pt-5 mb-2">
			<p class="fw-500 mb-0 pt-2 lh-1">
				Abaixo inclua o motivo para a rejeição. Os participantes listado acima receberam o status de
				<b class="text-danger">cancelado</b>
				.
			</p>
		</div>

		<div class="col-md-12">
			<div class="form-floating">
				<textarea class="form-control" appTextLimited [limited]="2000" style="height: 100px" [formControl]="descriptionControl"></textarea>
				<label>Descrição do motivo para a rejeição</label>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-link me-2" (click)="modal.dismiss()">
			<fa-icon icon="reply" class="me-2"></fa-icon>
			Voltar
		</button>

		<button class="btn btn-primary" (click)="confirmAllSupplierCanceled()" [disabled]="confirmSubmitted" *permissions="'dispute.proposal.cancel'">
			<app-label-loading-dots [loading]="confirmSubmitted" label="Confirmar"></app-label-loading-dots>
		</button>
	</div>
</ng-template>

<!--Modal request representation-->
<ng-template #modalRequestRepresentation let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">Diligência</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body bg-white">
		@if (listableRepresentations) {
			@if (supplierEnrollmentNotice && supplierEnrollmentNotice?.representations?.length > 0) {
				<ul class="list-group">
					@for (representation of supplierEnrollmentNotice.representations; track representation.id) {
						<li class="list-group-item">
							<div class="d-flex justify-content-between align-items-center mb-2">
								<small class="fw-600">Prazo {{ representation.expiresAt | date: "dd/MM/yyyy 'às' HH:mm" }}</small>

								@if (representation.messages?.length === 0) {
									<div>
										<button class="btn btn-sm btn-icon" (click)="editRepresentation(representation)">
											<fa-icon icon="edit"></fa-icon>
										</button>
									</div>
								}
							</div>
							<p class="mb-0 fw-400 lh-sm">{{ representation.message }}</p>
						</li>
						<li class="list-group-item bg-white border-0 p-0">
							<ul class="list-group rounded-0">
								@if (representation.messages?.length > 0) {
									<li class="list-group-item bg-white">
										<small class="fw-700">Resposta</small>
									</li>
									<li class="list-group-item bg-white border-bottom-lg p-0">
										<div class="d-flex mb-2 flex-column p-3">
											<p class="mb-0 lh-1">{{ representation.details.principal.message }}</p>
											<small class="text-muted text-end w-100">{{ representation.details.principal.created | date: 'dd/MM/yyyy' }}</small>
										</div>
										<ul class="list-group list-group-flush">
											<li class="list-group-item bg-white">
												<small class="fw-700">Anexos</small>
											</li>
											<li class="list-group-item bg-white">
												<div class="d-flex justify-content-between align-items-center">
													<b>1 - Documento principal</b>
													<button
														class="btn btn-sm btn-outline-light text-dark rounded-xl fw-600"
														[disabled]="representation.details.principal.submitted"
														(click)="
															sessionMessageAttachmentDownload(
																representation.details.principal,
																representation.details.principal.id
															)
														">
														<fa-icon icon="download" class="me-2"></fa-icon>
														<app-label-loading-dots
															[loading]="representation.details.principal.submitted"
															label="Baixar"></app-label-loading-dots>
													</button>
												</div>
											</li>
											@for (item of representation.details?.others; track item.id; let i = $index) {
												<li class="list-group-item bg-white">
													<div class="d-flex justify-content-between align-items-center">
														<b>{{ i + 2 }} - Complementar</b>
														<button
															class="btn btn-sm btn-outline-light text-dark rounded-xl fw-600"
															[disabled]="item.submitted"
															(click)="sessionMessageAttachmentDownload(item, item.id)">
															<fa-icon icon="download" class="me-2"></fa-icon>
															<app-label-loading-dots [loading]="item.submitted" label="Baixar"></app-label-loading-dots>
														</button>
													</div>
												</li>
											}
										</ul>
									</li>
								} @else {
									<li class="list-group-item">
										<small class="text-muted text-center d-inline-block w-100">Aguardando retorno do fornecedor.</small>
									</li>
								}
							</ul>
						</li>
					}
				</ul>
			} @else {
				<div class="d-flex justify-content-center align-items-center h-100 w-100">
					<app-empty-data message="Nenhuma diligência cadastrada..."></app-empty-data>
				</div>
			}
		} @else {
			<div class="row p-2">
				<div class="col-md-12 mb-3">
					<label for="message" class="form-label">Mensagem</label>
					<textarea
						id="message"
						style="height: 100px"
						placeholder="Mensagem"
						class="form-control form-control-lg"
						[formControl]="descriptionControl"></textarea>
				</div>
				<div class="col-md-12 mb-3">
					<label class="form-label" for="requestDate">Validade</label>
					<div class="input-group input-group-joined">
						<input
							class="form-control form-control-lg"
							type="text"
							id="requestDate"
							[owlDateTime]="requestDate"
							placeholder="dd/mm/yyyy HH:mm"
							[owlDateTimeTrigger]="requestDate"
							[formControl]="expiresAtControl"
							[owlDateTimeFilter]="DateValidator.isWeekend" />
						<div class="input-group-text">
							<i-feather name="calendar"></i-feather>
						</div>
					</div>
					<owl-date-time #requestDate [pickerType]="'both'"></owl-date-time>
				</div>
			</div>
		}
	</div>
	<div class="modal-footer">
		<div class="d-flex justify-content-end">
			@if (listableRepresentations) {
				<button class="btn btn-primary fw-600" (click)="listableRepresentations = false">Cadastrar Diligência</button>
			} @else {
				<button class="btn btn-link fw-600 me-2" (click)="listableRepresentations = true; noticeSessionRepresentation = null">Voltar</button>
				@if (noticeSessionRepresentation) {
					<button class="btn btn-primary" (click)="updateRepresentation()" [disabled]="submittedRepresentation || demand.noticeSession.statusClosed">
						<app-label-loading-dots [loading]="submittedRepresentation" label="Salvar"></app-label-loading-dots>
					</button>
				} @else {
					<button class="btn btn-primary" (click)="saveRepresentation()" [disabled]="submittedRepresentation || demand.noticeSession.statusClosed">
						<app-label-loading-dots [loading]="submittedRepresentation" label="Salvar"></app-label-loading-dots>
					</button>
				}
			}
		</div>
	</div>
</ng-template>

<!--Modal counterarguments supplier pending-->
<ng-template #modalCounterargumentSupplierPending let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">Pendência de Recursos</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<div class="col-md-12">
			@if (supplierEnrollmentCounterarguments && supplierEnrollmentCounterarguments.length > 0) {
				<ul class="list-group list-group-flush">
					@for (counter of supplierEnrollmentCounterarguments; track counter.id) {
						<ng-container *ngTemplateOutlet="counterargument; context: { counter, supplier: true }"></ng-container>
					}
				</ul>
			} @else {
				<app-empty-data message="Nenhuma pendência..."></app-empty-data>
			}
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-link me-2" (click)="modal.dismiss()">
			<fa-icon icon="reply" class="me-2"></fa-icon>
			Voltar
		</button>
	</div>
</ng-template>

<!--Modal view attachment-->
<ng-template #modalAttachment let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Anexo</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body m-0 p-0 overflow-y-hidden">
		@if (attachmentLoading) {
			<div class="d-flex h-100 align-items-center justify-content-center">
				<app-pre-loading></app-pre-loading>
			</div>
		} @else {
			@if (attachmentUrl) {
				@if (attachmentUrl === 'error') {
					<div class="d-flex h-100 align-items-center justify-content-center">
						<app-empty-data message="Não foi possível baixar o documento..."></app-empty-data>
					</div>
				} @else {
					<iframe [src]="attachmentUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
				}
			}
		}
	</div>
</ng-template>

<!--Modal view document-->
<ng-template #modalAttachmentView let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ attachmentTitle ?? 'Anexo' }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body m-0 p-0 overflow-y-hidden">
		@if (attachmentLoading) {
			<div class="d-flex h-100 align-items-center justify-content-center">
				<app-pre-loading></app-pre-loading>
			</div>
		} @else {
			@if (attachmentUrl) {
				@if (attachmentUrl === 'error') {
					<div class="d-flex h-100 align-items-center justify-content-center">
						<app-empty-data message="Não foi possível baixar o documento..."></app-empty-data>
					</div>
				} @else {
					<iframe [src]="attachmentUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
				}
			}
		}
	</div>
	@if (supplierEnrollmentNoticeAttachment?.certificated && !supplierEnrollmentNotice?.published) {
		<div class="modal-footer">
			<div class="w-100 d-flex align-items-center justify-content-center p-3">
				@if (submittedAttachmentLoading) {
					<app-pre-loading msg="Enviado o certificado, aguarde"></app-pre-loading>
				} @else {
					<app-empty-data message="Caso deseje substituir o certificado gerado, inclua um novo anexo abaixo." [noillustration]="true">
						<div class="w-100 d-flex justify-content-center pt-2">
							<input
								type="file"
								#fileAttachment
								(change)="
									attachmentNotice($event, supplierEnrollmentNoticeAttachment.id, afterAttachmentNoticeSupplierCertificatedReload.bind(this))
								"
								style="display: none" />
							<button class="btn btn-sm btn-primary fw-600 text-uppercase" (click)="fileAttachment.click()">
								Clique aqui para adicionar outro certificado
							</button>
						</div>
					</app-empty-data>
				}
			</div>
		</div>
	}
</ng-template>

<!--Modal confirm generate certs-->
<ng-template #modalConfirmCertificate let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">Gerar documentos complementares</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<p>Deseja gerar os documentos abaixo</p>
		<ul class="list-group">
			<li class="list-group-item">
				<div class="d-flex justify-content-between align-content-center">
					<p class="mb-0">{{ demand.process.modality === ProcessModality.ACCREDITATION ? 'Credenciamento' : 'Certificado' }}</p>
					<div class="d-flex align-content-center justify-content-center">
						@if (submittedGenerateCertificate) {
							<app-pre-loading [showMessage]="false" [inline]="true" [large]="false"></app-pre-loading>
						} @else {
							@if (errorGenerateCertificate) {
								<fa-icon class="text-danger" icon="times" ngbTooltip="Tívemos um problema ao tentar gerar o documento"></fa-icon>
							} @else {
								<fa-icon
									[ngbTooltip]="
										supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.REJECTED ? 'Este documento não será gerado' : ''
									"
									[class.text-danger]="supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.REJECTED"
									[class.text-success]="supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.APPROVED"
									[icon]="supplierEnrollmentNoticeStatus === SupplierEnrollmentNoticeStatus.REJECTED ? 'times' : 'check'"></fa-icon>
							}
						}
					</div>
				</div>
			</li>
			<li class="list-group-item">
				<div class="d-flex justify-content-between align-content-center">
					<p class="mb-0">Relatório de Análise</p>
					<div class="d-flex align-content-center justify-content-center">
						@if (submittedGenerateAnalytics) {
							<app-pre-loading [showMessage]="false" [inline]="true" [large]="false"></app-pre-loading>
						} @else {
							@if (errorGenerateAnalytics) {
								<fa-icon class="text-danger" icon="times" ngbTooltip="Tívemos um problema ao tentar gerar o documento"></fa-icon>
							} @else {
								<fa-icon class="text-success" icon="check"></fa-icon>
							}
						}
					</div>
				</div>
			</li>
		</ul>
	</div>
	<div class="modal-footer">
		<button class="btn btn-link me-2" (click)="modal.dismiss()">
			<fa-icon icon="reply" class="me-2"></fa-icon>
			Gerar depois
		</button>

		<button class="btn btn-primary" (click)="confirmSupplierGenerateCertificate()" [disabled]="confirmSubmitted">
			<app-label-loading-dots [loading]="confirmSubmitted" label="Gerar documentos"></app-label-loading-dots>
		</button>
	</div>
</ng-template>

<!--Modal attachment viewer supplier-->
<ng-template #modalAttachmentViewSupplier let-modal>
	<div class="modal-header">
		<h4 class="modal-title text-uppercase">Documentos | {{ participantDisplayName(supplierEnrollmentNotice) }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body m-0 p-0" style="overflow-x: hidden">
		<div class="row overflow-y-hidden h-100">
			@if (attachmentSidebar) {
				<div class="col-md-2 p-0 h-100">
					<ul class="list-group rounded-0 h-100 overflow-y-auto">
						<li class="list-group-item list-group-flush bg-light p-0 text-center">
							<button class="btn btn-link fw-600" [disabled]="attachmentLoading" (click)="documentAllDownload(supplierEnrollmentNotice)">
								@if (attachmentLoading) {
									Aguarde, baixando documentos...
								} @else {
									<i-feather name="download" class="me-2"></i-feather>
									Baixar Documentos
								}
							</button>
						</li>
						<li class="list-group-item list-group-flush bg-light pt-0">
							<div class="ps-3">
								<small class="text-muted">Total de {{ supplierEnrollmentNotice.viewAttachments.length }} documento(s)</small>
								<b class="d-inline-block w-100">Selecione um documento</b>
							</div>
						</li>
						@if (supplierEnrollmentNotice.demand.loose) {
							@for (attachment of supplierEnrollmentNotice.viewAttachments; track attachment.id; let i = $index) {
								<li
									class="list-group-item list-group-flush"
									[class.active]="attachment.documentation"
									(click)="selectAttachmentDownload(attachment)">
									<p class="mb-0 ps-3 fw-600 cursor-pointer">
										{{ attachment.other ? attachment.typeLabel + ' ' + i : attachment.typeLabel }}
									</p>
									<small class="ps-3">{{ attachment.created | date: 'dd/MM/yyyy HH:mm' }}</small>
								</li>
							}
						} @else {
							@for (attachment of supplierEnrollmentNotice.viewDisputeAttachments; track attachment.id; let i = $index) {
								<li
									class="list-group-item list-group-flush"
									[class.active]="attachment.documentation"
									(click)="selectAttachmentDownload(attachment)">
									<p class="mb-0 ps-3 fw-600 cursor-pointer">{{ attachment.description || attachment.typeLabel }}</p>
									@if (attachment.created) {
										<small class="ps-3">{{ attachment.created | date: 'dd/MM/yyyy HH:mm' }}</small>
									}
									@if (attachment.qualificationLabel) {
										<small class="ps-3 d-block text-muted lh-sm">{{ attachment.qualificationLabel }}</small>
									}
								</li>
							}
						}
					</ul>
				</div>
			}
			<div class="p-0" [class.col-md-10]="attachmentSidebar" [class.col-md-12]="!attachmentSidebar">
				@if (supplierEnrollmentNotice.submitted) {
					<div class="d-flex h-100 align-items-center justify-content-center">
						<app-pre-loading></app-pre-loading>
					</div>
				} @else {
					@if (supplierEnrollmentNotice.url) {
						@if (supplierEnrollmentNotice.url === 'error') {
							<div class="d-flex h-100 align-items-center justify-content-center">
								<app-empty-data message="Não foi possível baixar o documento..."></app-empty-data>
							</div>
						} @else {
							<iframe [src]="supplierEnrollmentNotice.url" width="100%" height="100%" [frameBorder]="0"></iframe>
						}
					}
				}
			</div>
		</div>
	</div>
</ng-template>

<!--Details counterarguments-->
<ng-template #counterargument let-counter="counter" let-supplier="supplier">
	<li class="list-group-item" [ngClass]="supplier ? 'border border-1' : ''">
		@if (supplier) {
			<div class="d-flex justify-content-between align-items-center">
				<div class="w-100">
					<small class="text-muted">{{ counter.supplierEnrollmentNotice.supplier.document | mask: 'CPF_CNPJ' }}</small>
					<p class="text-uppercase fw-700 mb-0">{{ counter.supplierEnrollmentNotice.supplier.name }}</p>
					<small class="w-100 d-inline-block">{{ label.formattedAddress(counter.supplierEnrollmentNotice.supplier.address) }}</small>
				</div>
			</div>
		}

		<div class="d-flex justify-content-between align-items-center pb-3 pt-3">
			<ng-template #supplierCounterargument>
				<div class="w-100 d-flex justify-items-start flex-column">
					<small class="small">Enviado por</small>
					<p class="fw-600 mb-0 lh-1">{{ counter.supplier.name }}</p>
					<p class="mb-0">{{ counter.supplier.document | mask: 'CPF_CNPJ' }}</p>
				</div>
			</ng-template>
			<small class="fw-700 cursor-pointer" [ngbTooltip]="supplierCounterargument">
				<fa-icon icon="circle-exclamation"></fa-icon>
				{{ counter.typeLabel }}
			</small>
			<div class="rounded-xl border border-1 border-gray-300 ps-1 bg-gray-100 d-flex align-items-center">
				@if (counter.status === CounterargumentStatus.CREATED) {
					<small class="fw-600 ps-2">Deferir</small>
					<div class="btn-group btn-group-sm">
						<button
							class="btn btn-link text-success"
							ngbTooltip="Deferir"
							(click)="modalCounterargumentJudging(counter, CounterargumentStatus.GRATED)"
							*permissions="'dispute.appeal.approve'">
							<fa-icon icon="check"></fa-icon>
						</button>
						<button
							class="btn btn-link text-danger"
							ngbTooltip="Indeferir"
							(click)="modalCounterargumentJudging(counter, CounterargumentStatus.REJECTED)"
							*permissions="'dispute.appeal.cancel'">
							<fa-icon icon="times"></fa-icon>
						</button>
					</div>
				} @else {
					<small class="ps-2 pe-2 fw-600" [class.text-danger]="counter.statusRejected" [class.text-success]="counter.statusGranted">
						{{ counter.statusLabel }}
					</small>
				}
			</div>
		</div>
		<p class="mb-0 lh-1">{{ counter.description ?? 'Nenhuma observação informada.' }}</p>
		<div class="d-flex justify-content-between align-items-center">
			<button class="btn bnt-link ps-0 border-0" (click)="counterargumentAttachmentDownload(counter)" [disabled]="counter.submitted">
				<fa-icon icon="download" class="pe-2"></fa-icon>
				{{ counter.submitted ? 'Baixando, aguarde...' : 'Baixar anexo' }}
			</button>
			<small class="fw-700">{{ counter.created | date: 'dd/MM/yyyy HH:mm' }}</small>
		</div>

		<div class="d-flex w-100 flex-column">
			@if (counter.counterarguments?.length > 0) {
				@for (counterargument of counter.counterarguments; track counterargument.id) {
					<ng-template #supplier>
						<div class="w-100 d-flex justify-items-start flex-column">
							<small class="small">Enviado por</small>
							<p class="fw-600 mb-0 lh-1">{{ counterargument.supplier.name }}</p>
							<p class="mb-0">{{ counterargument.supplier.document | mask: 'CPF_CNPJ' }}</p>
						</div>
					</ng-template>

					@if (counterargument.submitted) {
						<div class="d-flex justify-content-end m-5">
							<app-pre-loading [inline]="true" [large]="false" msg="Baixando, aguarde"></app-pre-loading>
						</div>
					} @else {
						<div class="d-flex justify-content-end mb-4">
							<div
								class="message-bubble user align-self-end cursor-pointer"
								style="min-width: 535px"
								(click)="counterargumentAttachmentDownload(counterargument)"
								[ngbTooltip]="supplier"
								[innerHTML]="counterargument.resolvedCounterargument"></div>
						</div>
					}
				}
			}
		</div>

		@if (!counter.statusCreated) {
			<div class="d-flex w-100">
				@if (counter.judgingDownloading) {
					<div class="d-flex justify-content-end m-5">
						<app-pre-loading [inline]="true" [large]="false" msg="Baixando, aguarde"></app-pre-loading>
					</div>
				} @else {
					<div
						class="message-bubble system align-self-start cursor-pointer"
						style="min-width: 535px"
						(click)="counterargumentAttachmentDownload(counter, true)"
						[ngbTooltip]="'Clique para baixar'"
						[innerHTML]="counter.agentJudging"></div>
				}
			</div>
		}
	</li>
</ng-template>

<!--Modal grated/rejected counterargument-->
<ng-template #modalGratedCounterargument let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ supplierEnrollmentNoticeStatusCounterargumentLabel }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body p-3">
		<div class="row">
			<div class="col-md-12 mb-3">
				<label for="description" class="form-label">Motivo por estar {{ supplierEnrollmentNoticeStatusCounterargumentLabel?.toLowerCase() }}</label>
				<textarea
					class="form-control"
					id="description"
					appTextLimited
					[limited]="2000"
					style="height: 100px"
					[formControl]="descriptionControl"></textarea>
			</div>
		</div>

		<div class="row">
			<div
				class="mb-3"
				[class.col-md-12]="!confirmSubmitted && !fileUploadAttachmentDocument?.status"
				[class.col-md-10]="confirmSubmitted || fileUploadAttachmentDocument?.status">
				<label for="file" class="form-label">Anexe um documento em PDF</label>
				<input
					class="form-control form-control-lg"
					[class.is-invalid]="fileAttachmentControlInvalid"
					(change)="onAttachmentSelected($event)"
					id="file"
					type="file"
					[disabled]="submittedAttachment" />
				@if (fileAttachmentControl.hasError('required')) {
					<div class="invalid-feedback">Informe o anexo</div>
				}
			</div>

			<div
				class="mt-3 d-flex align-items-center justify-content-center flex-column"
				[class.d-none]="!confirmSubmitted && !fileUploadAttachmentDocument?.status"
				[class.col-md-2]="confirmSubmitted || fileUploadAttachmentDocument?.status">
				@if (confirmSubmitted && fileUploadAttachmentDocument?.status !== 'UPLOADED') {
					<app-pre-loading [inline]="true" [large]="false" [showMessage]="false"></app-pre-loading>
					<p class="mb-0">Enviando</p>
				} @else if (fileUploadAttachmentDocument?.status === 'ERROR') {
					<small>
						<fa-icon icon="times-circle" class="text-danger" ngbTooltip="Tívemos um problema ao enviar o documento de habilitação"></fa-icon>
					</small>
					<p class="mb-0">Error</p>
				} @else if (fileUploadAttachmentDocument?.status === 'UPLOADED') {
					<small><fa-icon icon="check-circle" class="text-success" ngbTooltip="Enviado com sucesso"></fa-icon></small>
					<p class="mb-0">Enviado</p>
				}
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-link me-2" (click)="modal.dismiss()">
			<fa-icon icon="reply" class="me-2"></fa-icon>
			Voltar
		</button>

		<button class="btn btn-primary" (click)="confirmCounterargumentJudging()" [disabled]="confirmSubmitted">
			<app-label-loading-dots [loading]="confirmSubmitted" label="Confirmar"></app-label-loading-dots>
		</button>
	</div>
</ng-template>

<!--Modal bidding-->
<ng-template #modalBidding let-modal>
	@if (supplierEnrollmentNotice) {
		<div class="modal-header">
			<div class="w-100 d-flex justify-content-between align-items-center">
				<div>
					<h4 class="modal-title" id="modal-basic-title">{{ proposalsMenuLabel }}</h4>
					@if (demand?.qualificationInversion) {
						<small class="text-muted">Julgamento da habilitação — inversão de fases</small>
					}
				</div>
				<div class="d-flex align-items-center">
					<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
				</div>
			</div>
		</div>
		<div class="modal-body bg-white m-0 p-0">
			<!--
				Inversão de fases (spec 047): aceitar a proposta inicial é o julgamento da habilitação, antes dos lances.
				O agente decide vendo a documentação que o participante enviou junto da proposta; a falta fica em
				evidência, mas não bloqueia a decisão (RF-16).
			-->
			@if (demand?.qualificationInversion) {
				<div class="p-3 border-bottom">
					<div class="alert alert-info d-flex gap-2 mb-3">
						<fa-icon icon="file-contract" class="mt-1"></fa-icon>
						<div>
							<p class="mb-1 fw-700">Julgamento da habilitação</p>
							<p class="mb-0 small">
								Esta disputa tem inversão de fases: a habilitação é julgada antes dos lances. Aceitar a proposta inicial
								<b>habilita</b>
								o participante, que segue para a disputa; rejeitá-la o
								<b>inabilita</b>
								e ele sai da disputa.
							</p>
						</div>
					</div>

					<p class="mb-2 fw-600">Documentação de habilitação</p>
					@if (!hasQualificationDocumentation(supplierEnrollmentNotice)) {
						<div class="alert alert-warning d-flex align-items-center gap-2 py-2 mb-2">
							<fa-icon icon="circle-exclamation"></fa-icon>
							<span class="small">
								<b>O participante não enviou documentação de habilitação.</b>
								A falta não impede a decisão: habilitar ou inabilitar cabe ao agente.
							</span>
						</div>
					}
					<ul class="list-group">
						<li class="list-group-item d-flex justify-content-between align-items-center">
							<div>
								<p class="mb-0 fw-600">Comprovante da proposta</p>
								@if (supplierEnrollmentNotice.proposalAttachment) {
									@if (supplierEnrollmentNotice.proposalAttachmentAt) {
										<small class="text-muted">{{ supplierEnrollmentNotice.proposalAttachmentAt | date: 'dd/MM/yyyy HH:mm' }}</small>
									}
								} @else {
									<small class="text-muted">Não enviado</small>
								}
							</div>
							@if (supplierEnrollmentNotice.proposalAttachment) {
								<button class="btn btn-sm btn-outline-primary fw-600" (click)="viewQualificationInversionDocument(supplierEnrollmentNotice)">
									<fa-icon icon="download" class="me-1"></fa-icon>
									Visualizar
								</button>
							}
						</li>
						@for (attachment of qualificationInversionDocuments(supplierEnrollmentNotice); track attachment.id) {
							<li class="list-group-item d-flex justify-content-between align-items-center">
								<div>
									<p class="mb-0 fw-600">{{ attachment.description || attachment.typeLabel }}</p>
									@if (attachment.created) {
										<small class="text-muted">{{ attachment.created | date: 'dd/MM/yyyy HH:mm' }}</small>
									}
								</div>
								<button
									class="btn btn-sm btn-outline-primary fw-600"
									(click)="viewQualificationInversionDocument(supplierEnrollmentNotice, attachment)">
									<fa-icon icon="download" class="me-1"></fa-icon>
									Visualizar
								</button>
							</li>
						}
					</ul>
					@let otherDocuments = qualificationInversionOtherDocuments(supplierEnrollmentNotice);
					@if (otherDocuments.length > 0) {
						<p class="mt-3 mb-2 fw-600">Outros documentos enviados</p>
						<ul class="list-group">
							@for (attachment of otherDocuments; track attachment.id) {
								<li class="list-group-item d-flex justify-content-between align-items-center">
									<div>
										<p class="mb-0 fw-600">{{ attachment.description || attachment.typeLabel }}</p>
										@if (attachment.created) {
											<small class="text-muted">{{ attachment.created | date: 'dd/MM/yyyy HH:mm' }}</small>
										}
									</div>
									<button
										class="btn btn-sm btn-outline-primary fw-600"
										(click)="viewQualificationInversionDocument(supplierEnrollmentNotice, attachment)">
										<fa-icon icon="download" class="me-1"></fa-icon>
										Visualizar
									</button>
								</li>
							}
						</ul>
					}
				</div>
			}
			@if (items$ | async; as items) {
				@if (items?.length === 0) {
					<div class="d-flex align-items-center justify-content-center w-100" style="height: 550px">
						<app-empty-data></app-empty-data>
					</div>
				} @else {
					@if (isBidTypeBatch) {
						<div class="p-3">
							@for (batch of groupItemsByBatch(items); track batch.batchKey) {
								<div class="card shadow-sm border-0 mb-3">
									<div class="card-header bg-gray-100">
										<small class="text-muted d-block">{{ batch.batchExternalCode ? 'Lote ' + batch.batchExternalCode : 'Lote' }}</small>
										<p class="mb-0 fw-600 text-uppercase">{{ batch.batchDescription || 'SEM DESCRIÇÃO' }}</p>
									</div>
									<div class="table-responsive">
										<table class="table table-borderless p-0 mb-0">
											<thead>
												<tr>
													<th scope="col" class="ps-3" style="width: 70%">Descrição</th>
													<th scope="col" class="text-center">Unidade</th>
													<th scope="col" class="text-center">Valor</th>
													<th scope="col" class="text-center">Quantidade</th>
													<th scope="col" class="text-center">Total</th>
												</tr>
											</thead>
											<tbody>
												@for (item of batch.items; track item.id) {
													<tr>
														<td class="bg-gray-100 align-middle bg-white ps-3 fw-600">{{ item.description }}</td>
														<td class="bg-gray-100 align-middle bg-white text-center">
															{{ label.fromProductUnit(item.unit).label }}
														</td>
														<td class="bg-gray-100 align-middle bg-white text-center">{{ item.unitValue | currency: 'BRL' }}</td>
														<td class="bg-gray-100 align-middle bg-white text-center">{{ item.total | number }}</td>
														<td class="bg-gray-100 align-middle bg-white text-center">{{ item.totalAmount | currency: 'BRL' }}</td>
													</tr>
													@if (item.proposals?.length === 0 || !item.proposals) {
														<tr>
															<td colspan="5" class="bg-white">
																<small class="badge badge-sm text-bg-light border fw-600 ms-5 mb-2">
																	<fa-icon icon="circle-exclamation" class="me-1"></fa-icon>
																	Nenhuma proposta incluída
																</small>
															</td>
														</tr>
													}
													@if (item.proposals?.length > 0) {
														<tr>
															<td colspan="5" class="bg-white">
																<small class="text-muted ps-5">Últimas propostas</small>
															</td>
														</tr>
														<tr>
															<td colspan="5" class="p-0 m-0">
																<ul class="list-group list-group-flush bg-white ps-5">
																	@for (
																		proposal of getClassificationProposals(item);
																		track proposal.id || proposal.created;
																		let index = $index
																	) {
																		<li class="list-group-item bg-white">
																			<div class="d-flex justify-content-between align-items-center">
																				<div class="d-flex justify-content-center align-items-center">
																					<small class="fw-700" style="width: 40px">{{ index + 1 }}</small>
																					<small>{{ proposal.created | date: 'dd/MM/yyyy HH:mm' }}</small>
																				</div>
																				<div>
																					<p class="mb-0">
																						@if (proposal.qualified) {
																							<small class="badge badge-sm text-bg-success me-3">
																								<b>Qualificada</b>
																								@if (proposal.qualifiedAt) {
																									{{ proposal.qualifiedAt | date: 'dd/MM/yyyy HH:mm' }}
																								}
																							</small>
																						}
																						@if (proposal.brand) {
																							<small class="badge badge-sm text-bg-info me-3">
																								<b>Marca</b>
																								{{ proposal.brand }}
																							</small>
																						}
																						@if (proposal.trading) {
																							<small class="badge badge-sm text-bg-indigo me-3">
																								<b>Negociação</b>
																							</small>
																						}

																						@if (proposal.sealed) {
																							<!-- O servidor redige o valor antes da abertura da sessão (PC-01) e, no fechado e aberto, até a fase abrir (RN-26). -->
																							<small
																								class="badge badge-sm text-bg-light border fw-600"
																								[ngbTooltip]="sealedProposalHint"
																								container="body">
																								<fa-icon icon="lock" class="me-1"></fa-icon>
																								Sigiloso
																							</small>
																						} @else if (proposal.amount !== null && proposal.amount !== undefined) {
																							<small class="badge badge-sm text-bg-primary fw-600">
																								{{ proposal.amount | currency: 'BRL' }}
																							</small>

																							<small class="fw-700 ms-3">
																								{{ proposal.amount * item.total | currency: 'BRL' }}
																							</small>
																						} @else {
																							<small class="badge badge-sm text-bg-light border fw-600">
																								Sem valor — o preço não é julgado
																							</small>
																						}
																					</p>
																				</div>
																			</div>
																		</li>
																	}
																</ul>
															</td>
														</tr>
													}
												}
											</tbody>
										</table>
									</div>
								</div>
							}
						</div>
					} @else {
						<div class="table-responsive">
							<table class="table table-borderless p-0 mb-0">
								<thead>
									<tr>
										<th scope="col" class="ps-3" style="width: 70%">Descrição</th>
										<th scope="col" class="text-center">Unidade</th>
										<th scope="col" class="text-center">Valor</th>
										<th scope="col" class="text-center">Quantidade</th>
										<th scope="col" class="text-center">Total</th>
									</tr>
								</thead>
								<tbody>
									@for (item of items; track item.id) {
										<tr>
											<td class="bg-gray-100 align-middle bg-white ps-3 fw-600">{{ item.description }}</td>
											<td class="bg-gray-100 align-middle bg-white text-center">{{ label.fromProductUnit(item.unit).label }}</td>
											<td class="bg-gray-100 align-middle bg-white text-center">{{ item.unitValue | currency: 'BRL' }}</td>
											<td class="bg-gray-100 align-middle bg-white text-center">{{ item.total | number }}</td>
											<td class="bg-gray-100 align-middle bg-white text-center">{{ item.totalAmount | currency: 'BRL' }}</td>
										</tr>
										@if (item.proposals?.length === 0 || !item.proposals) {
											<tr>
												<td colspan="5" class="bg-white">
													<small class="badge badge-sm text-bg-light border fw-600 ms-5 mb-2">
														<fa-icon icon="circle-exclamation" class="me-1"></fa-icon>
														Nenhuma proposta incluída
													</small>
												</td>
											</tr>
										}
										@if (item.proposals?.length > 0) {
											<tr>
												<td colspan="5" class="bg-white">
													<small class="text-muted ps-5">Últimas propostas</small>
												</td>
											</tr>
											<tr>
												<td colspan="5" class="p-0 m-0">
													<ul class="list-group list-group-flush bg-white ps-5">
														@for (
															proposal of getClassificationProposals(item);
															track proposal.id || proposal.created;
															let index = $index
														) {
															<li class="list-group-item bg-white">
																<div class="d-flex justify-content-between align-items-center">
																	<div class="d-flex justify-content-center align-items-center">
																		<small class="fw-700" style="width: 40px">{{ index + 1 }}</small>
																		<small>{{ proposal.created | date: 'dd/MM/yyyy HH:mm' }}</small>
																	</div>
																	<div>
																		<p class="mb-0">
																			@if (proposal.qualified) {
																				<small class="badge badge-sm text-bg-success me-3">
																					<b>Qualificada</b>
																					@if (proposal.qualifiedAt) {
																						{{ proposal.qualifiedAt | date: 'dd/MM/yyyy HH:mm' }}
																					}
																				</small>
																			}
																			@if (proposal.brand) {
																				<small class="badge badge-sm text-bg-info me-3">
																					<b>Marca</b>
																					{{ proposal.brand }}
																				</small>
																			}
																			@if (proposal.trading) {
																				<small class="badge badge-sm text-bg-indigo me-3">
																					<b>Negociação</b>
																				</small>
																			}
																			@if (proposal.sealed) {
																				<!-- O servidor redige o valor antes da abertura da sessão (PC-01) e, no fechado e aberto, até a fase abrir (RN-26). -->
																				<small
																					class="badge badge-sm text-bg-light border fw-600"
																					[ngbTooltip]="sealedProposalHint"
																					container="body">
																					<fa-icon icon="lock" class="me-1"></fa-icon>
																					Sigiloso
																				</small>
																			} @else if (proposal.amount !== null && proposal.amount !== undefined) {
																				<small class="badge badge-sm text-bg-primary fw-600">
																					{{ proposal.amount | currency: 'BRL' }}
																				</small>

																				<small class="fw-700 ms-3">
																					{{ proposal.amount * item.total | currency: 'BRL' }}
																				</small>
																			} @else {
																				<small class="badge badge-sm text-bg-light border fw-600">
																					Sem valor — o preço não é julgado
																				</small>
																			}
																		</p>
																	</div>
																</div>
															</li>
														}
													</ul>
												</td>
											</tr>
										}
									}
								</tbody>
							</table>
						</div>
					}
				}
			} @else {
				<div class="d-flex align-items-center justify-content-center w-100" style="height: 550px">
					<app-pre-loading msg="Buscando items, aguarde"></app-pre-loading>
				</div>
			}
		</div>
		<div class="modal-footer">
			<div class="d-flex justify-content-end align-items-center">
				<button class="btn btn-sm btn-link me-2 fw-600" (click)="modal.close()">Voltar</button>
				<!-- Ajuste de 2026-09-21: aceitar/rejeitar a proposta inicial é ato da sessão EM ANDAMENTO (disputa e dispensa) — antes da abertura os botões não aparecem. -->
				@if (!loadingProposal && demand.noticeSession.statusOpened) {
					@if (!supplierEnrollmentNotice.statusRejected) {
						@if (canProposalQualifyRejected(supplierEnrollmentNotice)) {
							<button
								class="btn btn-sm btn-danger fw-600"
								(click)="proposalQualify('inapposite')"
								[disabled]="submittedProposalInapposite || submittedProposalAppropriate">
								<fa-icon icon="times-circle" class="me-2"></fa-icon>
								<app-label-loading-dots
									[loading]="submittedProposalInapposite"
									[label]="demand?.qualificationInversion ? 'Inabilitar' : 'Rejeitar'"></app-label-loading-dots>
							</button>
						}
						@if (hasAnyProposalInBids) {
							@if (demand.isDispute) {
								@if (supplierEnrollmentNotice.statusCreated || supplierEnrollmentNotice.statusProposalSent) {
									<button
										class="btn btn-sm btn-primary fw-600 ms-3"
										(click)="proposalQualify('appropriate')"
										[disabled]="submittedProposalInapposite || submittedProposalAppropriate">
										<fa-icon icon="check-double" class="me-2"></fa-icon>
										<app-label-loading-dots
											[loading]="submittedProposalAppropriate"
											[label]="demand?.qualificationInversion ? 'Habilitar' : 'Aceitar'"></app-label-loading-dots>
									</button>
								}
							} @else {
								@if (canProposalQualifyApprovedIsNotDispute(supplierEnrollmentNotice)) {
									<button
										class="btn btn-sm btn-primary fw-600 ms-3"
										(click)="proposalQualify('appropriate')"
										[disabled]="submittedProposalInapposite || submittedProposalAppropriate">
										<fa-icon icon="check-double" class="me-2"></fa-icon>
										<app-label-loading-dots
											[loading]="submittedProposalAppropriate"
											[label]="demand?.qualificationInversion ? 'Habilitar' : 'Aceitar'"></app-label-loading-dots>
									</button>
								}
							}
						}
					}
				}
			</div>
		</div>
	}
</ng-template>

<!--Modal trading-->
<ng-template #modalTrading let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">Negociação {{ trading?.id ? (trading.statusOpened ? 'Aberta' : '') : '' }}</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body bg-white">
		@if (loadingTrading) {
			<div class="d-flex justify-content-center align-items-center w-100 h-100">
				<app-pre-loading></app-pre-loading>
			</div>
		} @else {
			<div class="row p-2">
				<div class="col-md-12 mb-3">
					<label for="message" class="form-label">Mensagem</label>
					<textarea
						id="message"
						style="height: 100px"
						placeholder="Mensagem"
						class="form-control form-control-lg"
						[formControl]="descriptionControl"></textarea>
				</div>

				<div class="col-md-12">
					<label class="form-label">Itens da negociação</label>
					@if (loadingProposal) {
						<div class="d-flex justify-content-center align-items-center w-100 p-4">
							<app-pre-loading [inline]="true" [large]="false" msg="Buscando itens"></app-pre-loading>
						</div>
					} @else {
						@if (tradingItemsWithLatestProposal.length === 0) {
							<div class="p-3 border rounded">
								<small class="text-muted">Nenhum item com proposta encontrada.</small>
							</div>
						} @else {
							@if (isBidTypeBatch) {
								<div class="table-responsive border rounded">
									<table class="table table-sm table-borderless mb-0">
										<thead>
											<tr>
												<th>Lote</th>
												<th class="text-center">Itens</th>
												<th class="text-center">Proposta (Soma)</th>
												@if (!trading?.id || trading?.statusClosed) {
													<th class="text-center">Selecionar</th>
												}
											</tr>
										</thead>
										<tbody>
											@for (batch of tradingBatchGroups; track batch.batchKey) {
												<tr>
													<td class="align-middle">
														<div class="d-flex flex-column">
															<small class="text-muted">
																{{ batch.batchExternalCode ? 'Lote ' + batch.batchExternalCode : 'Lote' }}
															</small>
															<span class="fw-600">{{ batch.batchDescription || 'SEM DESCRIÇÃO' }}</span>
														</div>
													</td>
													<td class="align-middle text-center">{{ batch.items.length }}</td>
													<td class="align-middle text-center">{{ getTradingBatchProposalAmount(batch) | currency: 'BRL' }}</td>
													@if (!trading?.id || trading?.statusClosed) {
														<td class="align-middle text-center">
															<div class="form-check d-flex align-items-center justify-content-center mb-0">
																<input
																	class="form-check-input"
																	type="radio"
																	name="tradingBatchSelection"
																	[id]="'checkTradingBatch' + batch.batchKey"
																	[checked]="isTradingBatchSelected(batch.batchKey)"
																	(change)="toggleTradingBatch(batch.batchKey, $any($event.target).checked)" />
															</div>
														</td>
													}
												</tr>
											}
										</tbody>
									</table>
								</div>
							} @else {
								<div class="table-responsive border rounded">
									<table class="table table-sm table-borderless mb-0">
										<thead>
											<tr>
												<th>Item</th>
												<th class="text-center">Proposta</th>
												@if (!trading?.id || trading?.statusClosed) {
													<th class="text-center">
														<div class="form-check d-flex align-items-center justify-content-center mb-0">
															<input
																class="form-check-input"
																id="checkTradingAll"
																type="checkbox"
																[checked]="isTradingAllSelected"
																(change)="toggleAllTradingItems($any($event.target).checked)" />
														</div>
													</th>
												}
											</tr>
										</thead>
										<tbody>
											@for (item of tradingItemsWithLatestProposal; track item.id) {
												<tr>
													<td class="align-middle">{{ item.description }}</td>
													<td class="align-middle text-center">{{ item.latestProposal.amount | currency: 'BRL' }}</td>
													@if (!trading?.id || trading?.statusClosed) {
														<td class="align-middle text-center">
															<div class="form-check d-flex align-items-center justify-content-center mb-0">
																<input
																	class="form-check-input"
																	[id]="'checkTradingItem' + item.id"
																	type="checkbox"
																	[checked]="isTradingItemSelected(item.id)"
																	(change)="toggleTradingItem(item.id, $any($event.target).checked)" />
															</div>
														</td>
													}
												</tr>
											}
										</tbody>
									</table>
								</div>
							}
						}
					}
				</div>
			</div>
		}
	</div>
	<div class="modal-footer ps-4 pe-4">
		@if (!loadingTrading) {
			<div class="d-flex justify-content-between align-items-center w-100">
				<div>
					@if (trading?.created) {
						<small class="text-muted">
							Última alteração em
							<b>{{ trading.updated || trading.created | date: 'dd/MM/yyyy HH:mm' }}</b>
						</small>
					}
				</div>

				<div>
					@if (trading?.id) {
						@if (trading.statusOpened) {
							<button
								class="btn btn-danger fw-600"
								(click)="updateTrading(EnrollmentNoticeTradingStatus.CLOSED)"
								[disabled]="submittedProposal || demand.noticeSession.statusClosed">
								<fa-icon icon="times-circle" class="me-2"></fa-icon>
								<app-label-loading-dots [loading]="submittedProposal" label="Fechar Negociação"></app-label-loading-dots>
							</button>
						} @else if (trading.statusClosed) {
							<button
								class="btn btn-primary fw-600"
								(click)="updateTrading(EnrollmentNoticeTradingStatus.OPENED)"
								[disabled]="submittedProposal || demand.noticeSession.statusClosed || !hasTradingSelectedItems">
								<fa-icon icon="check-circle" class="me-2"></fa-icon>
								<app-label-loading-dots [loading]="submittedProposal" label="Abrir Negociação"></app-label-loading-dots>
							</button>
						}
					} @else {
						<button class="btn btn-primary" (click)="saveTrading()" [disabled]="submittedProposal || loadingProposal || !hasTradingSelectedItems">
							<app-label-loading-dots [loading]="submittedProposal" label="Salvar"></app-label-loading-dots>
						</button>
					}
				</div>
			</div>
		}
	</div>
</ng-template>

<!--Modal feasibility/adjusted proposal-->
<ng-template #modalFeasibilityAdjusted let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">{{ modalProposalType === 'adjusted' ? 'Proposta Readequada' : 'Exequibilidade' }}</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn btn-sm btn-icon me-2" ngbTooltip="Atualizar lista" (click)="refreshFeasibilityAdjustedProposalList()">
					<fa-icon icon="refresh"></fa-icon>
				</button>
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body bg-white">
		@if (listableProposal) {
			<ul class="list-group list-group-flush">
				@if (modalProposalType === 'feasibility') {
					@if (feasibility$ | async; as proposals) {
						@if (proposals.length === 0) {
							<div class="d-flex justify-content-center align-items-center w-100 h-100 p-5">
								<app-empty-data></app-empty-data>
							</div>
						} @else {
							@for (item of proposals; track item.id) {
								<li class="list-group-item bg-white pt-2 pb-2">
									<div class="d-flex justify-content-between align-items-center">
										<small class="text-muted me-2" ngbTooltip="Cadastrado em">
											{{ item.created | date: 'dd/MM/yyyy HH:mm' }}
										</small>
										<div>
											@if (!item.statusAnswer) {
												<button
													class="btn btn-sm btn-icon fw-600"
													[class.btn-danger]="!item.statusOpened"
													[class.btn-primary]="item.statusOpened"
													[ngbTooltip]="item.statusOpened ? 'Fechar a exequibilidade' : 'Abrir a exequibilidade'"
													(click)="closeOpenFeasibility(item, item.statusOpened)"
													[disabled]="item.submitted">
													@if (item.submitted) {
														<app-pre-loading [large]="false" [inline]="true" [showMessage]="false"></app-pre-loading>
													} @else {
														<fa-icon [icon]="item.statusOpened ? 'unlock' : 'lock'"></fa-icon>
													}
												</button>
											}
										</div>
									</div>
									<div class="d-flex justify-content-between align-items-center w-100">
										<div class="pt-3">
											<p class="mb-2 fw-600 lh-sm">{{ item.description }}</p>
											<small class="text-muted">Expira em {{ item.expiresAt | date: 'dd/MM/yyyy HH:mm' }}</small>
										</div>
									</div>
									<div class="d-flex justify-content-end mt-2">
										@if (item.latestAnswer) {
											@if (item.submitted) {
												<div class="d-flex justify-content-end m-5">
													<app-pre-loading [inline]="true" [large]="false" msg="Baixando, aguarde"></app-pre-loading>
												</div>
											} @else {
												<div
													class="message-bubble system align-self-start cursor-pointer"
													style="min-width: 535px"
													(click)="feasibilityAttachmentDownload(item)"
													[ngbTooltip]="'Clique para baixar'"
													[innerHTML]="item.latestAnswerMessage"></div>
											}
										}
									</div>
								</li>
							}
						}
					} @else {
						<div class="d-flex justify-content-center align-items-center w-100 h-100 p-5">
							<app-pre-loading></app-pre-loading>
						</div>
					}
				} @else if (modalProposalType === 'adjusted') {
					@if (adjusted$ | async; as proposals) {
						@if (proposals.length === 0) {
							<div class="d-flex justify-content-center align-items-center w-100 h-100 p-5">
								<app-empty-data></app-empty-data>
							</div>
						} @else {
							@for (item of proposals; track item.id) {
								<li class="list-group-item bg-white pt-2 pb-2">
									<div class="d-flex justify-content-between align-items-center">
										<small class="text-muted me-2" ngbTooltip="Cadastrado em">
											{{ item.created | date: 'dd/MM/yyyy HH:mm' }}
										</small>
										<div>
											@if (!item.statusAnswer) {
												<button
													class="btn btn-sm btn-icon fw-600"
													[class.btn-danger]="!item.statusOpened"
													[class.btn-primary]="item.statusOpened"
													[ngbTooltip]="item.statusOpened ? 'Fechar proposta readequada' : 'Abrir proposta readequada'"
													(click)="closeOpenAdjusted(item, item.statusOpened)"
													[disabled]="item.submitted"
													*permissions="'dispute.diligence.manage'">
													@if (item.submitted) {
														<app-pre-loading [large]="false" [inline]="true" [showMessage]="false"></app-pre-loading>
													} @else {
														<fa-icon [icon]="item.statusOpened ? 'unlock' : 'lock'"></fa-icon>
													}
												</button>
											}
										</div>
									</div>
									<div class="d-flex justify-content-between align-items-center w-100">
										<div class="pt-3">
											<p class="mb-2 fw-600 lh-sm">{{ item.description }}</p>
											<small class="text-muted">Expira em {{ item.expiresAt | date: 'dd/MM/yyyy HH:mm' }}</small>
										</div>
									</div>
									<div class="d-flex justify-content-end mt-2">
										@if (item.latestAnswer) {
											@if (item.submitted) {
												<div class="d-flex justify-content-end m-5">
													<app-pre-loading [inline]="true" [large]="false" msg="Baixando, aguarde"></app-pre-loading>
												</div>
											} @else {
												<div
													class="message-bubble system align-self-start cursor-pointer"
													style="min-width: 535px"
													(click)="adjustedAttachmentDownload(item)"
													[ngbTooltip]="'Clique para baixar'"
													[innerHTML]="item.latestAnswerMessage"></div>
											}
										}
									</div>
								</li>
							}
						}
					} @else {
						<div class="d-flex justify-content-center align-items-center w-100 h-100 p-5">
							<app-pre-loading></app-pre-loading>
						</div>
					}
				}
			</ul>
		} @else {
			<div class="row p-2">
				<div class="col-md-12 mb-3">
					<label for="message" class="form-label">Descrição</label>
					<textarea
						id="message"
						style="height: 100px"
						placeholder="Descrição"
						class="form-control form-control-lg"
						[formControl]="descriptionControl"></textarea>
				</div>
				<div class="col-md-12 mb-3">
					<label for="requestDate">Validade</label>
					<div class="input-group input-group-joined">
						<input
							class="form-control"
							type="text"
							id="requestDate"
							[owlDateTime]="requestDate"
							placeholder="dd/mm/yyyy HH:mm"
							[owlDateTimeTrigger]="requestDate"
							[formControl]="expiresAtControl"
							[owlDateTimeFilter]="DateValidator.isWeekend" />
						<div class="input-group-text">
							<i-feather name="calendar"></i-feather>
						</div>
					</div>
					<owl-date-time #requestDate [pickerType]="'both'"></owl-date-time>
				</div>
			</div>
		}
	</div>
	<div class="modal-footer">
		<div class="d-flex justify-content-end">
			@if (listableProposal) {
				<button type="button" class="btn btn-sm btn-link fw-600" (click)="modal.dismiss()">Voltar</button>
				<button class="btn btn-primary btn-sm rounded-xl fw-600" (click)="listableProposal = false">
					Adicionar {{ modalProposalType === 'adjusted' ? 'Proposta Readequada' : 'Exequibilidade' }}
				</button>
			} @else {
				<button class="btn btn-link text-danger me-3" (click)="listableProposal = true">Cancelar</button>
				<button
					class="btn btn-primary"
					(click)="saveFeasibilityAdjustedProposal()"
					[disabled]="submittedProposal"
					*permissions="'dispute.diligence.create'">
					<app-label-loading-dots [loading]="submittedProposal" label="Salvar"></app-label-loading-dots>
				</button>
			}
		</div>
	</div>
</ng-template>

<!--Modal log actives-->
<ng-template #modalLogAction let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Timeline</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body bg-white">
		<div class="row">
			<div class="col-md-12">
				<p class="text-muted p-5">
					Caso necessário é possível voltar um dos passos abaixo (apenas os habilitados) para fins de ajustes do processo em execução, está ação só
					irá refletir quando o processo e a sessão estiverem abertos.
				</p>
			</div>
			<div class="col-md-12 p-5">
				<div class="timeline timeline-xs mb-4">
					<div class="animated--fade-in">
						@if (activities && activities?.length > 0) {
							@for (activity of activities; track activity.ordering) {
								<div class="timeline-item">
									<div class="timeline-item-marker">
										<div class="timeline-item-marker-text" style="margin-top: -5px">
											@if (activity.loading) {
												<app-pre-loading [inline]="true" [large]="false" [showMessage]="false"></app-pre-loading>
											} @else {
												@if (activity.enabled && activity.undo && demand.noticeSession.statusOpened) {
													<button
														class="btn btn-sm btn-icon btn-info btn-undo"
														ngbTooltip="Voltar a linha do tempo para esse ponto"
														container="body"
														(click)="enrollmentUndo(activity)">
														<fa-icon icon="undo-alt"></fa-icon>
													</button>
												}
											}
										</div>
										<div class="timeline-item-marker-indicator" [ngClass]="activity.labelColor"></div>
									</div>
									<div class="timeline-item-content" style="margin-top: -5px" [innerHtml]="activity.content"></div>
								</div>
							}
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<!--Modal Participant Events-->
<ng-template #modalParticipantEvents let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title text-uppercase">
				Eventos {{ supplierEnrollmentNotice?.supplier?.name ? '— ' + participantDisplayName(supplierEnrollmentNotice) : '' }}
			</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
		</div>
	</div>
	<div class="modal-body" style="max-height: 70vh; overflow-y: auto">
		@if (participantEventsLoading) {
			<app-pre-loading msg="Buscando eventos, aguarde"></app-pre-loading>
		} @else {
			@if (participantEvents.length === 0) {
				<div class="p-5">
					<app-empty-data message="Nenhum evento encontrado..."></app-empty-data>
				</div>
			} @else {
				@for (group of participantEventGroups; track group.dateLabel) {
					<div class="d-flex align-items-center mb-3">
						<small class="badge badge-sm text-bg-light border fw-600 text-uppercase">{{ group.dateLabel }}</small>
						<hr class="flex-grow-1 ms-2 my-0" />
					</div>

					<ul class="timeline-events list-unstyled ps-2 mb-4">
						@for (event of group.items; track event.id) {
							<li class="timeline-events-item ps-4 pb-4 position-relative border-start border-secondary">
								<span
									class="position-absolute rounded-circle d-flex align-items-center justify-content-center text-white bg-secondary"
									style="width: 22px; height: 22px; left: -12px; top: 0">
									<fa-icon [icon]="eventSourceIcon(event.sourceTag)" style="font-size: 10px"></fa-icon>
								</span>

								<div class="d-flex justify-content-between align-items-center mb-1">
									<small class="text-muted">{{ event.sourceTag }} — {{ event.senderTag }}</small>
									<small class="text-muted">{{ event.created | date: 'HH:mm' }}</small>
								</div>

								@if (event.submitted) {
									<app-pre-loading [inline]="true" [large]="false" msg="Baixando anexo, aguarde"></app-pre-loading>
								} @else {
									<div
										class="message-bubble system align-self-start"
										style="max-width: 100%"
										[class.cursor-pointer]="event.hasAttachment"
										(click)="participantEventAttachmentDownload(event, event.resourceId ?? event.id)"
										[innerHTML]="event.customMessage"></div>
								}
							</li>
						}
					</ul>
				}
			}
		}
	</div>
</ng-template>

<!-- PC-11: recusa da proposta fora da inversão de fases, com o motivo da lista fechada, que vai para a ata. -->
<ng-template #modalProposalInapposite let-modal>
	<div class="modal-header">
		<h5 class="modal-title text-uppercase">Recusar proposta</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<p class="mb-3">
			Deseja realmente recusar a proposta do licitante
			<b>{{ supplierEnrollmentNotice?.supplier?.name }}</b>
			? O motivo e o complemento ficam registrados na ata.
		</p>

		<div class="form-floating mb-3">
			<select
				class="form-select"
				id="proposal-inapposite-reason"
				data-testid="proposal-inapposite-reason"
				[(ngModel)]="inappositeReason"
				[ngModelOptions]="{ standalone: true }">
				<option [ngValue]="null">Selecione</option>
				@for (option of proposalRejectionReasons; track option.value) {
					<option [ngValue]="option.value">{{ option.label }}</option>
				}
			</select>
			<label for="proposal-inapposite-reason">Motivo (obrigatório)</label>
		</div>

		<div class="form-floating">
			<textarea
				class="form-control"
				id="proposal-inapposite-description"
				style="height: 120px"
				maxlength="1000"
				placeholder="Complemento"
				[(ngModel)]="inappositeDescription"
				[ngModelOptions]="{ standalone: true }"></textarea>
			<label for="proposal-inapposite-description">Complemento</label>
		</div>
	</div>
	<div class="modal-footer">
		<a (click)="modal.dismiss()" class="btn btn-link me-2">Voltar</a>
		<button type="button" class="btn btn-danger fw-600" [disabled]="submittedProposalInapposite" (click)="confirmProposalInapposite()">
			<app-label-loading-dots [loading]="submittedProposalInapposite" label="Recusar proposta"></app-label-loading-dots>
		</button>
	</div>
</ng-template>
